<template>
  <div class="row" v-if="images.length">
    <div class="col-12">
      <Tinybox
        v-model="index"
        :images="images"
        style="z-index: 1021;"
      ></Tinybox>
    </div>
    <div class="col-md-4 mb-3" v-for="(file, index) in component.data.images" :key="index">
      <img :src="path(file)" class="img-fluid zoom" @click="select(index)"/>
    </div>
  </div>
</template>

<script>
import Tinybox from "vue-tinybox"

export default {
  components: {
    Tinybox,
  },
  props: ['component'],
  data(){return{
    index: null, 
  }},
  computed: {
    images() {
      return this.component.data.images.map(img => (this.path(img)))
    },
  },
  methods: {
    select(index) {
      this.index = index
    },
    path(file) {
      return `https://djceg34j53tq.cloudfront.net/${file}`
    },
  },
}
</script>

<style>
.zoom {
  cursor: zoom-in;
}
</style>